import { useDashToast as useToast } from '@dashhudson/dashing-ui/toast';

import { COMMUNITY_SPAM_UPDATE_TOASTS, conversationMessageTypes } from '@/app/community/constants';
import { useCommunityCommentsStore } from '@/stores/community-comments';
import { useCommunityInteractionStore } from '@/stores/community-interactions';

export function useInteractionActions() {
  const interactionStore = useCommunityInteractionStore();
  const commentsStore = useCommunityCommentsStore();
  const { addToast } = useToast({ life: 5000 });

  /**
   * Update spam status of an interaction
   * @param {string} interactionId - ID of the interaction to update
   * @param {boolean} newSpamValue - New spam status value
   * @param {Object} interaction - The interaction object for optimistic updates
   */
  async function updateSpamStatus(interactionId, newSpamValue, interaction) {
    const resp = await interactionStore.updateCommunityInteraction(
      interactionId,
      { isSpamOverride: newSpamValue },
      true,
      interaction,
    );

    if (resp.data?.data) {
      const message = newSpamValue
        ? COMMUNITY_SPAM_UPDATE_TOASTS.MARKED_SPAM
        : COMMUNITY_SPAM_UPDATE_TOASTS.MARKED_NOT_SPAM;
      addToast({
        severity: 'success',
        message,
      });

      // Update commentDetail spam status on success
      if (interaction.type && !conversationMessageTypes().includes(interaction.type)) {
        commentsStore.updateCommentStore({
          commentId: interaction.id,
          payload: { is_spam: newSpamValue },
        });
      }
    } else {
      addToast({
        severity: 'error',
        message: COMMUNITY_SPAM_UPDATE_TOASTS.ERROR,
      });
    }
  }

  return {
    updateSpamStatus,
  };
}
